module.exports = __webpack_public_path__ + "img/kejipub.6560c06e.png";